import { theme } from '@frontend/theme';
import { WeaveThemeValues } from '../../../component-theme/theme-types';

export type FullscreenModalHeaderTheme = {
  borderColor: WeaveThemeValues['Color'];
  spacing: WeaveThemeValues['Spacing'];
};

export const fullscreenModalHeaderTheme: FullscreenModalHeaderTheme = {
  borderColor: theme.colors.neutral50,
  spacing: theme.spacing,
};
